var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitybtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39862",
    "data-name": "Path 39862",
    d: "M26,22.8A3.2,3.2,0,0,1,22.8,26H5.2A3.2,3.2,0,0,1,2,22.8V5.2A3.2,3.2,0,0,1,5.2,2H22.8A3.2,3.2,0,0,1,26,5.2ZM11.6,6a3.2,3.2,0,0,1,3.1,2.4h6.1a.8.8,0,0,1,0,1.6H14.7a3.2,3.2,0,1,1-3.1-4Zm5.6,8.8a3.2,3.2,0,0,1,3.1,2.4h.5a.8.8,0,0,1,0,1.6h-.5a3.2,3.2,0,1,1-3.1-4ZM7.6,9.2a3.206,3.206,0,0,1,.1-.8H7.2a.8.8,0,1,0,0,1.6h.5A3.206,3.206,0,0,1,7.6,9.2Zm5.7,8a3.225,3.225,0,0,0,0,1.6H7.2a.8.8,0,1,1,0-1.6Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitybtnIcon);
export default __webpack_public_path__ + "static/media/activitybtn_Icon.3233bc0f69dc41222da768e0b4488bee.svg";
export { ForwardRef as ReactComponent };